import React, { useRef, useState, useEffect, useCallback } from 'react';
import DataGrid, { Column, DataGridTypes, Editing, Scrolling, Summary, TotalItem } from 'devextreme-react/data-grid';
import { Button } from 'devextreme-react/button';
import notistack from 'modules/core/notistack';
import { HttpStatus } from 'modules/core';
import { GetCustomOrderItemGridById } from '../service';
import { RenderImageCell } from 'modules/transactions/estimate-payment-receipt/estimate-payment-receipt/components/renderImageCell';

interface ShowCustomerOrderListModal {
    selectedId: number;
    handleClose(): void;
    reloadDataSource(): void;
}

const ShowCustomerOrderListModal: React.FC<ShowCustomerOrderListModal> = ({ selectedId, handleClose, reloadDataSource }) => {
    const dataGridRef = useRef<DataGrid>(null);
    const [gridData, setGridData] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const activeInputsRef = useRef<Map<string, HTMLInputElement>>(new Map());


    useEffect(() => {
        const loadData = async () => {
            try {
                setLoading(true);
                const response = await GetCustomOrderItemGridById(selectedId);
                setGridData(response.data);
            } catch (error) {
                console.error("Data loading error:", error);
                setGridData([]);
            } finally {
                setLoading(false);
            }
        };
        if (selectedId) {
            loadData();
        }
    }, [selectedId]);


    useEffect(() => {
        return () => {
            activeInputsRef.current.clear();
        };
    }, []);

    return (
        <>

            <DataGrid
                dataSource={gridData}
                keyExpr="id"
                ref={dataGridRef}
                showBorders={true}
                columnAutoWidth={true}
                columnHidingEnabled={false}
                wordWrapEnabled={false}
                repaintChangesOnly={true}
            >
                <Scrolling
                        mode='standard'
                        useNative={true}
                        scrollByContent={true}
                        scrollByThumb={true}
                    />
                <Column dataField="materialType" caption="Material Type" dataType="string" allowEditing={false} />
                <Column dataField="category" caption="Category" dataType="string" allowEditing={false} />
                <Column dataField="collection" caption="Collection" dataType="string" allowEditing={false} />
                <Column dataField="fromNetWeight" format="#,##0.000" caption="From Net Weight" dataType="number" allowEditing={false} />
                <Column dataField="toNetWeight" format="#,##0.000" caption="To Net Weight" dataType="number" allowEditing={false} />

                <Column dataField="goldRate" format="#,##0.00" caption="Gold Rate" dataType="number" allowEditing={false} />

                <Column
                    dataField="estimateAmount"
                    caption="Estimate Amount"
                    format="#,##0.00"
                    dataType="number"
                    allowEditing={false}
                />

                <Column
                    dataField="imageLink"
                    caption="Image"
                    width={80}
                    cellRender={RenderImageCell}
                />

                {/* <Column
                    dataField="calculatedWeight"
                    caption="Mayave Equivalent Weight"
                    dataType="number"
                    allowEditing={false}
                    format="#,##0.000"
                />

                <Column
                    dataField="finalAmount"
                    caption="Final Amount"
                    dataType="number"
                    allowEditing={false}
                    format="#,##0.00"
                /> */}

                {/* <Summary>
                    <TotalItem column="mayavePurity" summaryType="sum" displayFormat="Total" />
                    <TotalItem column="calculatedWeight" summaryType="sum" displayFormat="{0}" />
                    <TotalItem column="finalAmount" summaryType="sum" displayFormat="{0}" />
                </Summary> */}

            </DataGrid>

        </>
    );
};

export default ShowCustomerOrderListModal;